import { render, staticRenderFns } from "./RewardPass.vue?vue&type=template&id=33132f68&scoped=true"
import script from "./RewardPass.vue?vue&type=script&lang=js"
export * from "./RewardPass.vue?vue&type=script&lang=js"
import style0 from "./RewardPass.vue?vue&type=style&index=0&id=33132f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33132f68",
  null
  
)

export default component.exports